import React, { cloneElement } from 'react'
import { createRoot } from 'react-dom/client'

export default class Banner {
  constructor({ isFloating } = {}) {
    this.randomId = Math.floor(Math.random() * 1000)
    if (!document.getElementById(`BannerWrapper${this.randomId}`)) {
      let bannerWrapper = document.createElement('div')
      bannerWrapper.id = `BannerWrapper${this.randomId}`
      bannerWrapper.className = 'BannerWrapper'

      if (isFloating) {
        bannerWrapper.classList.add('BannerWrapperFloating')
      }
      bannerWrapper.dataset.sel = 'bnnr'

      document.body.appendChild(bannerWrapper)
    }
    this.root = createRoot(
      document.getElementById(`BannerWrapper${this.randomId}`)
    )
  }

  closeBanner = () => {
    const banner = document.getElementById(`BannerWrapper${this.randomId}`)

    banner.querySelector('.BannerContent').classList.add('animation-reverse')

    setTimeout(() => {
      this.root.render(null)
    }, 2000)
  }

  openBanner({ component, options = {}, ...props }) {
    props.closeBanner = () => {
      this.closeBanner(this)
    }
    const ComponentWithProps = cloneElement(component, props)

    this.root.render(
      <div className='Banner'>
        <div
          className={`BannerContent ${
            options.className ? options.className : ''
          }`}
          style={{ ...options.styles }}>
          {ComponentWithProps}
        </div>
      </div>
    )
  }
}
